<template>
  <div class="flex gap-2">
    <VaIconMenuCollapsed
      class="cursor-pointer"
      :class="{ 'x-flip': !isSidebarMinimized }"
      :color="collapseIconColor"
      @click="isSidebarMinimized = !isSidebarMinimized"
    />

    <nav class="flex items-center">
      <VaBreadcrumbs>
        <VaBreadcrumbsItem label="Home" :to="{ name: 'dashboard' }" />
        <VaBreadcrumbsItem
          v-for="item in items"
          :key="item.label"
          :label="item.label"
          @click="handleBreadcrumbClick(item)"
        />
      </VaBreadcrumbs>
    </nav>

    <div v-if="route.name === 'dashboard'" class="page-header-right ms-auto">
      <DateRangePicker
        ref="picker"
        v-model="date_range"
        opens="left"
        :date-range="date_range"
        @update:modelValue="update_date"
      ></DateRangePicker>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import DateRangePicker from 'vue3-daterange-picker/src/components/DateRangePicker.vue'
import { useUserStore } from 'obst/user-store'
import moment from 'moment'
import { useI18n } from 'vue-i18n'
import { useColors } from 'vuestic-ui'
import VaIconMenuCollapsed from '../icons/VaIconMenuCollapsed.vue'
import { storeToRefs } from 'pinia'
import { useGlobalStore } from '../../stores/global-store'
import NavigationRoutes from '../sidebar/NavigationRoutes'

const userStorage = useUserStore()

const { isSidebarMinimized } = storeToRefs(useGlobalStore())

const router = useRouter()
const route = useRoute()
const { t } = useI18n()

const date_range = ref({ ...userStorage.dashboardDate })

const update_date = function (data) {
  const res = {}
  res['startDate'] = moment(data['startDate']).format('YYYY-MM-DD')
  res['endDate'] = moment(data['endDate']).format('YYYY-MM-DD')
  userStorage.dashboardDate = res
}

type BreadcrumbNavigationItem = {
  label: string
  to: string
  hasChildren: boolean
}

const findRouteName = (name: string) => {
  const traverse = (routers: any[]): string => {
    for (const router of routers) {
      if (router.name === name) {
        return router.displayName
      }
      if (router.children) {
        const result = traverse(router.children)
        if (result) {
          return result
        }
      }
    }
    return ''
  }

  return traverse(NavigationRoutes.routes)
}

const items = computed(() => {
  const result: { label: string; to: string; hasChildren: boolean }[] = []
  route.matched.forEach((route) => {
    const labelKey = findRouteName(route.name as string)
    if (!labelKey) {
      return
    }
    result.push({
      label: t(labelKey),
      to: route.path,
      hasChildren: route.children && route.children.length > 0,
    })
  })
  return result
})

const { getColor } = useColors()

const collapseIconColor = computed(() => getColor('secondary'))

const handleBreadcrumbClick = (item: BreadcrumbNavigationItem) => {
  if (!item.hasChildren) {
    router.push(item.to)
  }
}
</script>

<style lang="scss">
.x-flip {
  transform: scaleX(-100%);
}
//.daterangepicker.openscenter{
//  transform:translate(-80%, 0) !important;
//}
.reportrange-text {
  padding: 10px 15px !important;
  font-size: 12px !important;
  color: #283c50 !important;
  font-weight: 500 !important;
  text-transform: uppercase;
  border: 1px solid #dcdee4;
  border-radius: 5px;
}
</style>
